import {
  GET_PATIENT_CONTENT,
  DELETE_PATIENT_CONTENT,
  UPDATE_PATIENT_CONTENT
} from "resources/ApiUrls"
import MyAxiosInstance from "utils/MyAxiosInstance"

const getAll = (userId) => MyAxiosInstance.get(GET_PATIENT_CONTENT(userId))

const update = (contentId, fieldsToUpdate) => MyAxiosInstance.patch(UPDATE_PATIENT_CONTENT(contentId), fieldsToUpdate)

const remove = (contentId) => MyAxiosInstance.delete(DELETE_PATIENT_CONTENT(contentId))

const messagesAPICalls = { getAll, update, remove }

export default messagesAPICalls